/* ==========================================================
   NURÉVE — Startseite „Produkte zuerst“
   Farbwahl, Bildwechsel und „In den Warenkorb“ direkt auf der Startseite.
   Der Warenkorb-Drawer im Header öffnet sich nach /cart/add von selbst.
   ========================================================== */
(function () {
  if (window.__nrvHome) return;
  window.__nrvHome = true;

  function item(el) { return el.closest('[data-nrvhm-item]'); }

  function setImage(root, url) {
    if (!url) return;
    var img = root.querySelector('img.nrvhm-main');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    root.classList.add('is-picked');
  }

  function setAddState(root, available) {
    root.querySelectorAll('[data-nrvhm-add]').forEach(function (btn) {
      btn.disabled = !available;
      btn.classList.remove('is-done');
      if (btn.hasAttribute('data-label')) {
        btn.textContent = available ? btn.getAttribute('data-label') : 'Ausverkauft';
      }
    });
  }

  function setStock(root, dot) {
    var line = root.querySelector('[data-nrvhm-stock]');
    if (!line) return;
    var txt = line.querySelector('span');
    var th = parseInt(root.getAttribute('data-th'), 10) || 5;
    var qty = parseInt(dot.getAttribute('data-qty'), 10);
    var tracked = dot.getAttribute('data-tracked') === 'true';
    var title = dot.getAttribute('data-title') || '';
    if (tracked && qty <= 0) {
      txt.textContent = title + ' ist aktuell ausverkauft';
      line.hidden = false;
    } else if (tracked && qty <= th) {
      txt.textContent = 'Nur noch ' + qty + ' Stück in ' + title;
      line.hidden = false;
    } else {
      line.hidden = true;
    }
  }

  function pick(dot) {
    var root = item(dot);
    if (!root) return;
    root.setAttribute('data-variant', dot.getAttribute('data-id'));
    root.querySelectorAll('[data-nrvhm-dot]').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setImage(root, dot.getAttribute('data-img'));
    var title = dot.getAttribute('data-title') || '';
    root.querySelectorAll('[data-nrvhm-thumb]').forEach(function (t) {
      var vt = t.getAttribute('data-vt');
      t.classList.remove('is-on');
      t.hidden = !!vt && vt !== title;
    });
    var price = root.querySelector('[data-nrvhm-price]');
    if (price && dot.getAttribute('data-price')) price.textContent = dot.getAttribute('data-price');
    setAddState(root, dot.getAttribute('data-available') === 'true');
    setStock(root, dot);
  }

  function add(btn) {
    var root = item(btn);
    if (!root || btn.disabled) return;
    var id = parseInt(root.getAttribute('data-variant'), 10);
    if (!id) return;
    var label = btn.getAttribute('data-label');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.classList.add('is-done');
      if (label) btn.textContent = 'Im Warenkorb';
      setTimeout(function () {
        btn.classList.remove('is-done');
        if (label) btn.textContent = label;
        btn.disabled = false;
      }, 2200);
    }).catch(function () {
      if (label) btn.textContent = 'Nicht mehr verfügbar';
      setTimeout(function () {
        if (label) btn.textContent = label;
        btn.disabled = false;
      }, 2600);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var dot = t.closest('[data-nrvhm-dot]');
    if (dot) { e.preventDefault(); pick(dot); return; }

    var thumb = t.closest('[data-nrvhm-thumb]');
    if (thumb) {
      e.preventDefault();
      var root = item(thumb);
      if (!root) return;
      setImage(root, thumb.getAttribute('data-img'));
      root.querySelectorAll('[data-nrvhm-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === thumb); });
      return;
    }

    var btn = t.closest('[data-nrvhm-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });
})();
